import { validateNotNullOrUndefined } from '@weft/utils';
import { withSuspenseBoundary } from 'apps/app/src/components/utility/SuspenseBoundary';
import { useHomePage } from 'apps/app/src/hooks/requests/pages/use-home-page';
import { useHomePageBillingCycle } from 'apps/app/src/hooks/requests/pages/use-home-page-billing-cycle';
import { HomePageBillingCohortSection } from '../new-home-page-components/home-page-billing-cohort/HomePageBillingCohortSection';
import { HomePageEndOfMonthClosureSection } from '../new-home-page-components/home-page-end-of-month-closure/HomePageEndOfMonthClosureSection';
import { HomePageInvoiceStatusSection } from '../new-home-page-components/home-page-invoice-status/HomePageInvoiceStatusSection';
import { HomePageQuickLinksSection } from '../new-home-page-components/home-page-quick-links/HomePageQuickLinksSection';
import { HomePageTopCustomersSection } from '../new-home-page-components/home-page-top-customers/HomePageTopCustomersSection';

const HomePageOverviewTabContent = () => {
  const { data: { homePageData: homePageResponse } } = useHomePage();
  const { data: homePageBillingCycle } = useHomePageBillingCycle({ suspense: true });

  validateNotNullOrUndefined(homePageBillingCycle, 'homePageBillingCycle');

  return (
    <>
      <HomePageQuickLinksSection/>

      <HomePageEndOfMonthClosureSection billingCycleInformation={homePageBillingCycle.currentBillingCycleInformation}/>

      <HomePageInvoiceStatusSection
        comparisonsData={homePageResponse.invoicesSummary.comparisons}
        invoiceStatusData={homePageResponse.invoicesSummary.revenueByBillingStatus}
      />

      <HomePageTopCustomersSection topCustomersData={homePageResponse.topRevenueChangeCustomers}/>

      <HomePageBillingCohortSection />
    </>
  );
};

const HomePageOverviewTabWithSuspense = withSuspenseBoundary(HomePageOverviewTabContent);

export { HomePageOverviewTabWithSuspense as HomePageOverviewTab };